import { SuccessMessage } from "../components/Successful"
import styles from "./style.module.css"

export const Congratulation = () => {
    return (
        <>
<main className={styles.body}>
            <div className={styles.container}>
                <SuccessMessage />
            </div>
            </main>

        </>
    )
}